export class CartOptionModel {
  page: string;
  isLoading: boolean;
  enableSticky: boolean;
  displayHotel: boolean;
  displayConfirmBookingBtn: boolean;

  constructor(page: string = 'cart') {
    this.page = page;
    this.isLoading = false;
    this.enableSticky = false;
    this.displayHotel = false;
    this.displayConfirmBookingBtn = false;
  }
}

export class TermsCondition {
  template: string;
  linkSupplier: string;
  linkAgent: string;
}

export const TermsConditionsType = {
  SUPPLIER: 'supplier',
  AGENT: 'agent'
}

export const TermsConditionsTemplate = {
  SUPPLIER: 'supplier',
  SUPPLIER_AGENT: 'supplier_agent'
}



// WEBPACK FOOTER //
// ./src/app/components/cart/cart-option.model.ts